import accountForm from '@/lang/views/accountSetting/AccountForm-en'
import attendanceSummaryList from '@/lang/components/dashboard/AttendanceSummaryList-en'
import employeeStatusGraph from '@/lang/components/dashboard/EmployeeStatusGraph-en'
import averageCheckInGraph from '@/lang/components/dashboard/AverageCheckInGraph-en'
import onsiteTodayTable from '@/lang/components/dashboard/OnsiteTodayTable-en'
import blacklist from '@/lang/views/blacklist/Blacklist-en'
import blacklistForm from '@/lang/views/blacklist/BlacklistForm-en'
import bureau from './components/companySetting/Bureau-en'
import companyProfile from '@/lang/components/companySetting/CompanyProfile-en'
import companySetting from '@/lang/views/companySetting/CompanySetting-en'
import dashboard from '@/lang/views/dashboard/Dashboard-en'
import deleteModal from '@/lang/components/modal/DeleteModal-en'
import deviceManagement from '@/lang/views/deviceManagement/DeviceManagement-en'
import employee from '@/lang/views/employee/Employee-en'
import { en } from 'vuetify/lib/locale'
import errorModal from '@/lang/components/modal/ErrorModal-en'
import logoutModal from '@/lang/components/modal/LogoutModal-en'
import positions from '@/lang/views/companySetting/Positions-en'
import sidebar from '@/lang/components/Sidebar-en'
import specialWorkday from '@/lang/components/timeTableSetting/SpecialWorkday-en'
import specialWorkdayFormModal from './components/timeTableSetting/SpecialWorkdayFormModal-en'
import timeTableSetting from './views/timeTableSetting/TimeTableSetting-en'
import toggleStatus from '@/lang/components/ToggleStatus-en'
import userForm from '@/lang/views/UserForm-en'
import userManagement from '@/lang/components/companySetting/UserManagement-en'
import lineService from '@/lang/components/companySetting/LineService-en'
import assignDeviceModal from '@/lang/components/deviceManagement/AssignDeviceModal-en'
import workday from '@/lang/components/timeTableSetting/Workday-en'
import workdayForm from '@/lang/components/timeTableSetting/WorkdayForm-en'
import employeeImport from '@/lang/views/employee/EmployeeImport-en'
import employeeImportImage from '@/lang/components/employee/EmployeeImportImage-en'
import employeeImportList from '@/lang/components/employee/EmployeeImportList-en'
import importEmployeesFormModal from '@/lang/components/modal/ImportEmployeesFormModal-en'
import lineRegister from '@/lang/views/liff/LineRegister-en'
import checkInOnsite from '@/lang/views/liff/CheckInOnsite-en'
import holiday from '@/lang/components/timeTableSetting/Holiday-en'
import holidayFormModal from './components/timeTableSetting/HolidayFormModal-en'
import activityLog from '@/lang/views/activityLog/ActivityLog-en'
import punchLog from '@/lang/views/punchLog/PunchLog-en'
import inquiry from '@/lang/components/inquiryAndAttendance/Inquiry-en'
import inquiryForm from '@/lang/components/inquiryAndAttendance/InquiryForm-en'
import statusAttendance from '@/lang/components/inquiryAndAttendance/StatusAttendance-en'
import statusAttendanceForm from '@/lang/components/inquiryAndAttendance/StatusAttendanceForm-en'
import manageAttendance from '@/lang/components/inquiryAndAttendance/ManageAttendance-en'
import manageAttendanceForm from '@/lang/components/inquiryAndAttendance/ManageAttendanceForm-en'
import punchLogAttendance from '@/lang/components/inquiryAndAttendance/PunchLog-en'
import visitorActivity from '@/lang/components/visitor/VisitorActivity-en'
import visitorList from '@/lang/components/visitor/VisitorList-en'
import login from '@/lang/views/authentication/Login-en'
import forgotPassword from '@/lang/views/authentication/ForgotPassword-en'
import resetPassword from '@/lang/views/authentication/ResetPassword-en'
import resetPasswordExpired from '@/lang/views/authentication/ResetPasswordExpired-en'

// line liff
import leaveRequest from '@/lang/views/liff/modules/Inquiry/LeaveRequest-en'
import InquiryOverview from '@/lang/views/liff/modules/Inquiry/Overview-en'
import InquiryBureau from '@/lang/views/liff/modules/Inquiry/Bureau-en'
import VisitorCreate from '@/lang/views/liff/modules/Visitor/VisitorCreate-en'
import AttendanceBureau from '@/lang/views/liff/modules/History/AttendanceBureau-en'
import AttendanceOverview from '@/lang/views/liff/modules/History/AttendanceOverview-en'
import AttendanceOverviewDetail from '@/lang/views/liff/modules/History/AttendanceOverviewDetail-en'
import HistoryAttendance from '@/lang/views/liff/modules/History/HistoryAttendance-en'
import HistoryOnsite from '@/lang/views/liff/modules/History/HistoryOnsite-en'
import HistoryQuota from '@/lang/views/liff/modules/History/HistoryQuota-en'
import PunchLogSecurity from '@/lang/views/liff/modules/Security/PunchLogSecurity-en'
import PunchLogSecurityDetail from '@/lang/views/liff/modules/Security/PunchLogSecurityDetail-en'
import DatepickerCustom from '@/lang/views/liff/modules/DatePicker/DatepickerCustom-en'
import visitor from '@/lang/views/visitor/visitor-en'
import visitorInfo from '@/lang/views/visitor/visitorInfo-en'
import visitorForm from '@/lang/components/visitor/VisitorForm-en'
// end line liff
import uploadimage from '@/lang/components/UploadImage-en'

export default {
    ...en,
    attendanceSummaryList,
    employeeStatusGraph,
    averageCheckInGraph,
    onsiteTodayTable,
    login,
    bureau,
    blacklistForm,
    deleteModal,
    errorModal,
    userForm,
    sidebar,
    dashboard,
    logoutModal,
    specialWorkday,
    specialWorkdayFormModal,
    timeTableSetting,
    toggleStatus,
    companyProfile,
    companySetting,
    userManagement,
    blacklist,
    accountForm,
    positions,
    employee,
    deviceManagement,
    workday,
    workdayForm,
    employeeImport,
    employeeImportImage,
    employeeImportList,
    importEmployeesFormModal,
    assignDeviceModal,
    lineRegister,
    checkInOnsite,
    holiday,
    holidayFormModal,
    lineService,
    visitor,
    visitorInfo,
    visitorForm,
    // line liff
    leaveRequest,
    InquiryOverview,
    InquiryBureau,
    VisitorCreate,
    AttendanceBureau,
    AttendanceOverviewDetail,
    AttendanceOverview,
    HistoryAttendance,
    HistoryOnsite,
    HistoryQuota,
    PunchLogSecurity,
    PunchLogSecurityDetail,
    activityLog,
    punchLog,
    inquiry,
    inquiryForm,
    statusAttendance,
    statusAttendanceForm,
    manageAttendance,
    manageAttendanceForm,
    punchLogAttendance,
    visitorActivity,
    visitorList,
    forgotPassword,
    resetPassword,
    resetPasswordExpired,
    DatepickerCustom,
    uploadimage
}
